const initialStore = {
  login: false,
  dataLogin: {},
};

export default initialStore;
